module.exports = __webpack_public_path__ + "img/text.85c266be.png";